@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../app-brand/concepts/shipstation-concept-layer-default.module.less';
@import '../../../constants/spacing.module.less';

.batch-list-item-button {
  padding-right: @space-24;
  border-radius: 0;
}

.move-to-batch-modal {
  width: 400px;
}

.modal-body {
  padding: 0;
  max-height: 400px;
  overflow: auto;
}

.modal-footer {
  height: initial;
  > button {
    margin-left: 10px;
  }
}

.loading-indicator {
  height: 400px;
  width: 100%;
  padding: 20px;
}

.section-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  width: 100%;
  height: 36px;
  background: @move-to-batch-modal--header--background-color;
  font-size: 13px;
  color: @move-to-batch-modal--header--text-color;
  border-bottom: 1px solid @move-to-batch-modal--header--border-color;
  z-index: 2;
  margin: 0;
}

.row {
  display: flex;
  align-items: center;
  height: 32px;
  background: @move-to-batch-modal--row--background-color;
  border-bottom: 1px solid @move-to-batch-modal--row--border-color;

  &:hover {
    background: var(--add-to-batch-menu--button--hover--background-color);
  }
}

.batch-list-item-wrapper {
  width: 100%;
}

.create-batch-button {
  width: 100%;
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 40px;
  color: @move-to-batch-modal--button--text-color;
  background: @move-to-batch-modal--button--background-color;
  font-size: 14px;
  border-top: 1px solid @move-to-batch-modal--button--border-color;
  box-shadow: 0 -2px 2px @move-to-batch-modal--button--box-shadow-color;
  cursor: pointer;
  margin-top: -1px;
  z-index: 3;

  &:hover {
    background: @move-to-batch-modal--button--hover--background-color;
  }
}
